import e from "react";
import { locales as t } from "../languages/index.mjs";
const n = e.createContext(t.en), l = ({
  i18n: o = t.en,
  ...r
}) => /* @__PURE__ */ e.createElement(n.Provider, { ...r, value: o });
export {
  n as I18nContext,
  l as KnockI18nProvider
};
//# sourceMappingURL=KnockI18nProvider.mjs.map
